import React, { CSSProperties, useMemo } from 'react'
import { Menu, Icon } from 'semantic-ui-react'
import PromiseButton from '../../../../components/PromiseButton'
import { useSelector } from '../../../../hooks/useSelector'
import usePlayerActions from '../../hooks/usePlayerActions'
import './Quests.scss'
import { Popup, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@prometheus/components'
import PromiseButtonV2 from '@/components/PromiseButtonV2'
import { ActiveQuests, GameBoard } from '@prometheus/types'
import useGameBoard from '../../hooks/useGameBoard'
import { parseAndRenderMessage } from '../../../../utils/messageParser'
import { useGameBoardActions } from '../../hooks/useGameBoardActions'
// import usePlayerActions from '../../hooks/usePlayerActions';

interface QuestItemProps {
  r: ActiveQuests
  board: GameBoard
}

const QuestItem = ({ r, board }: QuestItemProps) => {
  const turn = useSelector(s => s.game.metadata?.turn) || 0
  const { onUpgradePlanet } = usePlayerActions()
  const { focusPlanet } = useGameBoardActions()
  const objective = useMemo(() => {
    const parsedMessage = parseAndRenderMessage(r.objective_message ?? '', {
      board: board || {},
      focusPlanet,
    })
    
    return (
      <Typography key={r.objective_message}>
        {parsedMessage}
      </Typography>
    )
  }, [r.objective_message, board])
  return (
    <TableRow key={r.id}>
      <TableCell style={{ verticalAlign: 'top' }}>
        {r.complete ? (
          <Typography color="warning">-</Typography>
        ) : (
          <Typography style={{ whiteSpace: 'nowrap' }}>{(r.deadline ?? 0) - turn} years</Typography>
        )}
      </TableCell>
      <TableCell style={{ verticalAlign: 'top' }}>
        <Typography color={r.complete ? 'success' : 'warning'}>
          {(r.complete ? 'Complete' : 'Incomplete')}
        </Typography>
      </TableCell>
      <TableCell style={{ verticalAlign: 'top' }}>
        <Typography>
          {objective}
        </Typography>
      </TableCell>
      <TableCell style={{ verticalAlign: 'top' }}>
        <Typography style={{ whiteSpace: 'pre-wrap' }}>
          {r.reward_message}{r.reward_charges && r.reward_charges > 0 ? `\n\nCan be used ${r.reward_charges} times.` : r.reward_activated === false ? `.\n\nCan be active for ${r.reward_duration} years.` : ''}
        </Typography>
      </TableCell>
      <TableCell align="right" style={{ verticalAlign: 'top' }}>
        {!r.complete ? (
          <PromiseButtonV2 onClick={() => onUpgradePlanet([r], 'submit_quest')} outline size="xs" variant="primary">
            Submit ✓
          </PromiseButtonV2>
        ) : (
          <Typography align="right" style={{ whiteSpace: 'nowrap' }}>
            {r.reward_activated === true ? r.reward_duration ? `activated for ${r.reward_duration} years` : `${r.reward_charges} charges remaining` : (
              <PromiseButtonV2 size="xs" variant="tertiary" onClick={() => onUpgradePlanet([r], 'activate_reward')}
                key={`${r.id} reward`} // this is just a key, any string I want I believe, so can replace this with whatever we like (tried adding my own string and its fine!)
              >
                Activate
              </PromiseButtonV2>
            )}
          </Typography>
        )}
      </TableCell>
    </TableRow>
  )
}

export const QuestsHoverOver = () => {
  const quests = useSelector(s => s.game.sheet?.quests)
  const turn = useSelector(s => s.game.metadata?.turn) || 0
  const board = useSelector(s => s.game.game_board)
  const { onUpgradePlanet } = usePlayerActions()
  // const { onUpgradePlanet } = usePlayerActions();

  return (
    <>
      <Popup hoverable trigger={(
        <Menu.Item>
          <Icon name = "tasks" color="blue" />
          Quests
        </Menu.Item>
      )}>
        <div style={{ width: 'min(1000px, calc(100vw - 20px))', maxHeight: 'min(600px, 70dvh)', overflowY: 'auto' }} className="cr-breakdown">
          <div className="cr-header" style={{ justifyContent: 'center', textAlign: 'center' }}>
            Quests
          </div>
          <Table striped>
            <TableHead>
              <TableRow variant="head">
                <TableCell variant="head">Deadline</TableCell>
                <TableCell variant="head">Status</TableCell>
                <TableCell variant="head">Requirements</TableCell>
                <TableCell variant="head">Rewards</TableCell>
                <TableCell align="right" variant="head">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {!!board && quests?.active_quests.map(r => {
                return (
                  <QuestItem r={r} key={r.id} board={board} />
                )
              })}
            </TableBody>
          </Table>
        </div>
        {/* <div style={{ width: '1000px' }} className="q-breakdown">
          <div className="q-header" style={{ justifyContent: 'center', textAlign: 'center' }}>
            Quests Available
          </div>
          <div className="q-content">
            <div className={'minicolumn bold'} style={{ justifyContent: 'center', textAlign: 'center' }}>Submit Quest?</div>
            <div className={'minicolumn bold'} style={{ justifyContent: 'center', textAlign: 'center' }}>Quest Deadline</div>
            <div className={'minicolumn bold'} style={{ justifyContent: 'center', textAlign: 'center' }}>Quest <br/> Status</div>
            <div className={'columns bold center'} style={{ justifyContent: 'center', textAlign: 'center' }}>Quest <br/>Requirements</div>
            <div className={'columns bold'} style={{ justifyContent: 'center', textAlign: 'center' }}>Quest <br/>Rewards</div>
            <div className={'minicolumn bold'} style={{ justifyContent: 'center', textAlign: 'center' }}>Activate Reward?</div>
          </div>
          {quests?.active_quests.map(r => {
            return (
              <div key={r.id} className="q-content">
                <div className={'minicolumn'}>
                  {r.complete ? 'Quest Completed' :
                    <PromiseButton style={{ size:'tiny' }} onClick={() => onUpgradePlanet([r], 'submit_quest')}
                      key={r.id + 'submit'} // this is just a key, any string I want I believe, so can replace this with whatever we like (tried adding my own string and its fine!)
                      className={'padded'}
                    >
                        +
                    </PromiseButton>
                  }
                </div>
                <div className={'minicolumn'}>{r.complete ? '' : (r.deadline || 0) - turn + ' years'}</div>
                <div className={'minicolumn'} style={{ color: `${r.complete ? 'green' : 'black'}` }}>{(r.complete ? 'Complete' : 'Incomplete') }</div>
                <div className={'columns'}><span style={{ textAlign: 'left' }}>{r.objective_message}</span></div>
                <div className={'columns'}>
                  {r.reward_message}{r.reward_charges && r.reward_charges > 0 ? ` Can be used ${r.reward_charges} times.` : r.reward_activated === false ? `. Can be active for ${r.reward_duration} years.` : ''}
                </div>

                <div className={'minicolumn'}>
                  {r.reward_activated === true ? r.reward_duration ? `activated for ${r.reward_duration} years` : `${r.reward_charges} charges remaining` :
                    <PromiseButton style={{ size:'tiny' }} onClick={() => onUpgradePlanet([r], 'activate_reward')}
                      key={`${r.id} reward`} // this is just a key, any string I want I believe, so can replace this with whatever we like (tried adding my own string and its fine!)
                      className={'padded'}
                    >
                      +
                    </PromiseButton>}
                </div>
              </div>
            )
          })}
        </div> */}
      </Popup>
    </>
  )
}
